<template>
  <div id="app">
    <div class="mx-auto" style="width: 500px;">
      <b-list-group v-if="reference">
        <b-list-group-item class="bg-light">{{displayRef(reference.reference.code)}}</b-list-group-item>
        <b-list-group-item>{{reference.reference.designation}}</b-list-group-item>
        <b-list-group-item>
          <b-badge variant="info">{{reference.nbr_card}} cartes</b-badge>de
          <b-badge variant="info">{{reference.batch_size}} unités</b-badge>
          <b-badge>{{reference.reference.emplacement}}</b-badge>
        </b-list-group-item>
        <b-list-group-item>
          <b-badge variant="danger" v-if="andonRotation">
            Rotation faible
            <b-badge pill variant="light" v-if="andonRotation">{{reference.reference.rotation}}</b-badge>
          </b-badge>
          <b-badge variant="danger" v-if="andonLowStock">
            Stock faible
            <b-badge
              pill
              variant="light"
              v-if="andonRotation"
            >{{steps['En Préparation']['cards'].length}} / {{reference.nbr_card}}</b-badge>
          </b-badge>
        </b-list-group-item>
      </b-list-group>
    </div>
    <div v-if="hippoIsLoading" style="margin-top: 10%;">
      <i class="fa fa-spinner fa-spin fa-2x fa-fw"></i>
    </div>
    <div id="hyppo" class="mx-auto" v-if="loaded">
      <div id="hyppo-background"></div>
      <div id="stock">
        <workstation-item
          :step="steps['En Préparation']"
          :reference="reference"
          list-position="right"
        />
      </div>
      <div id="cell1">
        <workstation-item
          :step="steps['Cellule 1']"
          :reference="reference"
          list-position="left"
        />
      </div>
      <div id="cell2">
        <workstation-item
          :step="steps['Cellule 2']"
          :reference="reference"
          list-position="left"
        />
      </div>
      <div id="cell3">
        <workstation-item
          :step="steps['Cellule 3']"
          :reference="reference"
          list-position="left"
        />
      </div>
      <link-info
        :info="steps['En Préparation']['from_previous_takt']"
        class="link-from"
        id="link-from-cells-to-prep"
      />
      <link-info
        :info="steps['Cellule 1']['from_previous_takt']"
        class="link-from"
        id="link-from-prep-to-cell1"
      />
      <link-info
        :info="steps['Cellule 2']['from_previous_takt']"
        class="link-from"
        id="link-from-prep-to-cell2"
      />
      <link-info
        :info="steps['Cellule 3']['from_previous_takt']"
        class="link-from"
        id="link-from-prep-to-cell3"
      />
      <!-- <link-info :info="steps['Cellule 2']['to_next_takt']" id="link-from-cmd" /> -->
      <!-- <link-info :info="steps['Cellule 3']['to_next_takt']" id="link-from-cell3" /> -->
    </div>
  </div>
</template>

<script>
import server from '../../../api/server.vue'
import { Steps } from '../../../core/services/steps.js'
import { Utils } from '../../../core/utils/utils.js'
import WorkstationItem from '../hippodrome/WorkstationItem.vue'
import LinkInfo from '../detailed/LinkInfo.vue'
import moment from 'moment'

export default {
  name: 'AndonInternalReference',
  props: [],
  data () {
    return {
      kanban_id: '',
      reference: null,
      andonRotation: false,
      cardInStock: '?',
      stepList: Steps,
      andonLowStock: false,
      loaded: false,
      hippoIsLoading: true,
      steps: JSON.parse(JSON.stringify(Steps))
    }
  },
  methods: {
    displayDelay (since) {
      var now = moment()
      return now.diff(moment(since), 'days')
    },
    displayRef (reference) {
      return this.chunk(reference, 3)
    },
    singleFifoPromise (card_id) {
      return server.getFifoAndonFromCard(card_id).then(result => {
        return [card_id, result.data.andon]
      })
    },
    addFifoAndon (cards) {
      const promises = []
      for (const card_id in cards) {
        promises.push(this.singleFifoPromise(card_id))
      }
      return Promise.all(promises).then(values => {
        for (var item in values) {
          this.cards[values[item][0]].fifo = values[item][1]
        }
        return true
      })
    },
    singleUnseenPromise (card_id) {
      return server.getUnseenCardAndonFromCard(card_id).then(result => {
        return [card_id, result.data.andon]
      })
    },
    addUnseenCardAndon (cards) {
      const promises = []
      for (const card_id in cards) {
        promises.push(this.singleUnseenPromise(card_id))
      }
      return Promise.all(promises).then(values => {
        for (var item in values) {
          this.cards[values[item][0]].unseen_card = values[item][1]
        }
        return true
      })
    },
    addStdTime (cards) {
      return server.getKanbanReferenceStats(this.reference.reference.code,
                                            'loop_usual_components')
                    .then(result => {
        for (const step in result.data.stats) {
          if (step in this.steps) {
            let nbDay = (result.data.stats[step] / 3600 / 24).toFixed(1)
            if (isNaN(nbDay)) {
              nbDay = '?'
            } else {
              nbDay = nbDay + ' J'
            }
            this.steps[step].to_next_idle = nbDay
          }
        }
        for (const step in result.data.takt_time) {
          if (step in this.steps) {
            let nbDay = (result.data.takt_time[step] / 3600 / 24).toFixed(1)
            if (isNaN(nbDay)) {
              nbDay = '?'
            } else {
              nbDay = nbDay + ' J'
            }
            this.steps[step].to_next_takt = nbDay
          }
        }
        return true
      })
    },
    sortCardByStep (cards) {
      // this.steps = JSON.parse(JSON.stringify(Steps))
      for (const [key, value] of Object.entries(cards)) {
        if (value.last_scan && !_.isEmpty(value.last_scan)) {
          value.last_scan.created_for = this.displayDelay(
            value.last_scan.created_at
          )
        }
        if (
          value.last_scan &&
          !_.isEmpty(value.last_scan) &&
          value.last_scan.workstation.name &&
          !_.isEmpty(value.last_scan.workstation.name)
        ) {
          this.steps[value.last_scan.workstation.name].cards.push(value)
        } else {
          this.steps['En Préparation'].cards.push(value)
        }
      }
      for (var step in this.steps) {
        this.steps[step].cards.sort((a, b) => {
          if (_.isEmpty(a.last_scan) || _.isEmpty(b.last_scan)) {
            return -1
          }
          return a.last_scan.created_for < b.last_scan.created_for
            ? 1
            : a.card_index > b.card_index
              ? 1
              : -1
        })
      }
    }
  },
  mounted: function () {
    for (var key in this.steps) {
      this.steps[key].cards = []
    }

    this.kanban_id = this.$route.params.reference.toUpperCase()
    server
      .getKanbanReferenceInfosByKanbanReference(this.kanban_id, 'loop_usual_components')
      .then(result => {
        this.reference = result.data
        this.reference.emplacement =
          this.reference.zone +
          this.reference.pos_y +
          Utils.pad(this.reference.pos_x) +
          this.reference.pos_z
        this.andonRotation =
          parseFloat(this.reference.rotation) < 10
        server.getAllAndonLowStockRef(this.kanban_id).then(result => {
          this.andonLowStock = result.data.length > 0
        })
      })
    server.getCardFromReference(this.kanban_id, 'loop_usual_components').then(result => {
      this.cards = result.data.cards
      this.addFifoAndon(this.cards)
        .then(() => this.addUnseenCardAndon(this.cards))
        .then(() => this.addStdTime(this.cards))
        .then(() => {
          this.sortCardByStep(this.cards)
          this.loaded = true
          this.hippoIsLoading = false
          this.$forceUpdate()
        })

      //
    })
  },
  components: { WorkstationItem, LinkInfo }
// eslint-disable-next-line
};
</script>

<style type="text/css" scoped>
#hyppo {
  position: relative;
  background-image: url('../../../assets/hyppo-back-internal2.png');
  background-size: contain;
  background-repeat: no-repeat;
  width: 1023px;
  height: 782px;
}
#cell1 {
  position: absolute;
  top: 100px;
  left: 540px;
}
#cell2 {
  position: absolute;
  top: 320px;
  left: 540px;
}
#cell3 {
  position: absolute;
  top: 545px;
  left: 540px;
}
#stock {
  position: absolute;
  top: 120px;
  left: 5px;
}

.bl-list {
  position: absolute;
  top: 140px;
  left: 232px;
  width: 110px;
}
#waiting-time-cell1 {
  position: absolute;
  top: 2%;
  left: 18.5%;
}
#waiting-time-cell2 {
  position: absolute;
  top: 2%;
  left: 49%;
}
#waiting-time-cell3 {
  position: absolute;
  top: 2%;
  left: 79%;
}
#waiting-time-stock {
  position: absolute;
  top: 60%;
  left: 26.5%;
}
#link-from-cells-to-prep {
  position: absolute;
  top: 50%;
  left: 4.5%;
}
#link-from-prep-to-cell1 {
  position: absolute;
  top: 6%;
  left: 61%;
}
#link-from-prep-to-cell2 {
  position: absolute;
  top: 34%;
  left: 61%;
}
#link-from-prep-to-cell3 {
  position: absolute;
  top: 63%;
  left: 61%;
}
.link-info .badge {
  font-size: 1.3em !important;
}

</style>

<style type="text/css">
.link-from span
{
  background-color: rgb(139, 150, 173) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/andon/intern_hippo/internal_hippodrome.vue